import { _Atom } from "./Atom";
import { _Computed } from "./Computed";
/**
 * Returns true if the given value is a signal (either an Atom or a Computed).
 * @public
 */ export function isSignal(value) {
    return value instanceof _Atom || value instanceof _Computed;
}
